import { extendServiceContainer } from '@iotize/tap';
import { SlaveServerServiceExtended } from './service-custom';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    slaveServer: SlaveServerServiceExtended;
  }
}

export const _TAP_SERVICE_EXTENSION_SLAVESERVER_ = extendServiceContainer(
  'slaveServer',
  SlaveServerServiceExtended,
);
